import colors from "../../../../utils/colors";

const FILTER_CONTROL_HEIGHT = 36;
const brandBlue = colors.primary[300];

/** Free-text search — same white/blue chip look on all event filter bars. */
export const eventSearchInputSx = {
  height: FILTER_CONTROL_HEIGHT,
  minWidth: 220,
  maxWidth: 300,
  flex: "0 1 260px",
  "& .MuiOutlinedInput-root": {
    height: FILTER_CONTROL_HEIGHT,
    minHeight: FILTER_CONTROL_HEIGHT,
    maxHeight: FILTER_CONTROL_HEIGHT,
    borderRadius: "8px",
    fontSize: 14,
    backgroundColor: "#fff",
    boxSizing: "border-box",
    alignItems: "center",
    transition: "border-color 140ms ease, background-color 140ms ease, box-shadow 140ms ease",
    "& fieldset": {
      borderColor: colors.neutral[200],
      transition: "border-color 140ms ease",
    },
    "&:hover": {
      backgroundColor: "rgba(99, 113, 247, 0.08)",
      "& fieldset": { borderColor: brandBlue },
      "& .event-search-icon": { color: brandBlue },
    },
    "&.Mui-focused": {
      backgroundColor: "rgba(99, 113, 247, 0.06)",
      "& fieldset": { borderColor: brandBlue },
      "& .event-search-icon": { color: brandBlue },
    },
  },
  "& input.MuiOutlinedInput-input": {
    paddingTop: 0,
    paddingBottom: 0,
    height: "20px",
    lineHeight: "20px",
    boxSizing: "border-box",
    color: colors.neutral[800],
    "&::placeholder": {
      color: colors.neutral[600],
      opacity: 1,
    },
  },
  "& .MuiInputAdornment-root": {
    marginRight: 0.5,
    height: "auto",
    maxHeight: FILTER_CONTROL_HEIGHT,
  },
};
